module.exports = __webpack_public_path__ + "static/img/banner17@2x.7f20dd9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner17@2x.jpeg
// module id = P7jy
// module chunks = 1